import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';



const MatchCard = ({ match, onSendMessage, onRequestReveal, onScheduleMeeting, onArchive, isSelected, onSelect }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getStageColor = (stage) => {
    const colors = {
      'Initial Connection': 'bg-blue-100 text-blue-700',
      'In Conversation': 'bg-purple-100 text-purple-700',
      'Reveal Pending': 'bg-amber-100 text-amber-700',
      'Reveal Approved': 'bg-emerald-100 text-emerald-700',
      'Meeting Scheduled': 'bg-cyan-100 text-cyan-700'
    };
    return colors?.[stage] || 'bg-gray-100 text-gray-700';
  };

  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 hover:border-gray-300 transition-colors shadow-sm">
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="flex-shrink-0">
          <div className="w-14 h-14 rounded-lg overflow-hidden bg-gradient-to-br from-[#0025cc] to-[#0025cc] flex items-center justify-center">
            <Icon name="User" size={24} color="#FFFFFF" />
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-3">
            <div className="flex-1 min-w-0">
              <h3 className="text-lg font-semibold text-[#111827] mb-2 truncate">
                {match?.title}
              </h3>
              <p className="text-sm text-[#6B7280] line-clamp-2">
                {match?.description}
              </p>
            </div>
            <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium whitespace-nowrap ${getStageColor(match?.stage)}`}>
              {match?.stage}
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
            <div className="flex items-center gap-2 text-sm text-[#6B7280]">
              <Icon name="Calendar" size={16} className="flex-shrink-0" />
              <span className="truncate">Connected {formatDate(match?.connectedDate)}</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-[#6B7280]">
              <Icon name="MessageSquare" size={16} className="flex-shrink-0" />
              <span className="truncate">{match?.messageCount} messages</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-[#6B7280]">
              <Icon name="Briefcase" size={16} className="flex-shrink-0" />
              <span className="truncate">{match?.industry}</span>
            </div>
          </div>

          {match?.lastMessage && (
            <div className="bg-gray-50 rounded-lg p-4 mb-4">
              <div className="flex items-start gap-2">
                <Icon name="MessageCircle" size={16} className="flex-shrink-0 text-[#5B2DFF] mt-0.5" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-[#6B7280] mb-1">Last message</p>
                  <p className="text-sm text-[#111827] line-clamp-2">{match?.lastMessage}</p>
                  <p className="text-sm text-[#6B7280] mt-1.5">{formatDate(match?.lastMessageDate)}</p>
                </div>
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex gap-3">
            <button
              onClick={onSendMessage}
              className="flex-1 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
            >
              <Icon name="MessageSquare" size={16} />
              Message
            </button>

            {match?.stage === 'In Conversation' && (
              <button
                onClick={onRequestReveal}
                className="flex-1 px-4 py-2.5 bg-purple-600 hover:bg-purple-700 text-white text-sm font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
              >
                <Icon name="Shield" size={16} />
                Request Reveal
              </button>
            )}

            {match?.stage === 'Reveal Approved' && (
              <button
                onClick={onScheduleMeeting}
                className="flex-1 px-4 py-2.5 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
              >
                <Icon name="Calendar" size={16} />
                Schedule Meeting
              </button>
            )}

            <button
              onClick={onArchive}
              className="px-4 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-medium rounded-lg transition-colors"
              title="Archive"
            >
              <Icon name="Archive" size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchCard;